import React, { useEffect, useState } from "react";
import {
  Linking,
  ScrollView,
  StyleSheet,
  Text as RNText,
  TouchableOpacity,
  View,
} from "react-native";
import { Box, Flex, Text, useColorMode, useToast } from "native-base";

import { useNavigation, useRoute } from "@react-navigation/native";
import createStyles from "./styles";
import Template from "../../template/Index";
import { CommonActions } from "@react-navigation/native";
import { useTheme } from "../../../ThemeProvider";
import {
  AntDesign,
  Feather,
  FontAwesome,
  MaterialCommunityIcons,
} from "@expo/vector-icons";
import { CORES, sombraCard } from "../../template/Etapas/styles";
import { corComAlpha, corTextoSobre, gradienteHero } from "../../theme/cores";

const DIAS_SEMANA = [
  "Domingo",
  "Segunda-feira",
  "Terça-feira",
  "Quarta-feira",
  "Quinta-feira",
  "Sexta-feira",
  "Sábado",
];
const DIAS_CURTOS = [
  "domingo",
  "segunda",
  "terça",
  "quarta",
  "quinta",
  "sexta",
  "sábado",
];
const MESES_CURTOS = [
  "JAN",
  "FEV",
  "MAR",
  "ABR",
  "MAI",
  "JUN",
  "JUL",
  "AGO",
  "SET",
  "OUT",
  "NOV",
  "DEZ",
];

function circulo(tamanho: number, top: number, right: number): React.CSSProperties {
  return {
    position: "absolute",
    width: tamanho,
    height: tamanho,
    top,
    right,
    borderRadius: "50%",
    border: "1px solid rgba(255,255,255,0.12)",
    pointerEvents: "none",
  };
}
import { Card } from "primereact/card";
import { useToastMessage } from "../../hooks/useToastMessage";

export default function Comprovante({}) {
  const { primaryColor, isMobile, configEmpresa } = useTheme();

  const [parametros, setParametros] = useState<any>(null);

  const toast = useToast();
  const navigation = useNavigation();
  const route = useRoute();

  const { colorMode } = useColorMode();
  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa),
  );

  const { success } = useToastMessage();

  const styles = createStyles(getConfigEmpresa.coresPWA);

  useEffect(() => {
    const parametros_recebidos = route.params as any;
    setParametros(parametros_recebidos);
    messageSucesso();
  }, []);

  const messageSucesso = () => {
    success("Atenção", "Agendamento realizado com sucesso");
  };

  const getIconByTitle = (title: string) => {
    const titleLower = title.toLowerCase();

    if (titleLower.includes("detalhes") || titleLower.includes("agendamento")) {
      return "calendar-check";
    } else if (titleLower.includes("pagamento")) {
      return "cash-multiple";
    } else if (
      titleLower.includes("políticas") ||
      titleLower.includes("politicas")
    ) {
      return "shield-check";
    } else if (titleLower.includes("cancelamento")) {
      return "cancel";
    } else {
      return "information"; // ícone padrão
    }
  };

  function renderLinhaFinal() {
    return (
      <Box width={"100%"}>
        <Text style={styles.heading}>Políticas de Cancelamento</Text>

        <Box style={styles.container}>
          <Text style={styles.dateLabelFinal}>
            Se precisar, você tem a opção de cancelar ou alterar seu agendamento
            até 1 hora antes do horário estipulado. Para isso, acesse sua conta
            e siga as instruções disponíveis.
          </Text>
        </Box>
      </Box>
    );
  }
  function renderLinha(
    titulo_principal: String,
    subtitulo: String,
    valor: String,
    isValor: Boolean = false,
    top_menor: Boolean = false,
  ) {
    return (
      <Box width={"100%"}>
        <Flex direction="row" alignItems="center">
          <Text
            style={[
              styles.heading,
              {
                marginTop: top_menor ? 5 : 20,
                borderBottomColor:
                  getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao,
              },
            ]}
            fontSize="lg"
          >
            <MaterialCommunityIcons
              name={getIconByTitle(titulo_principal.toString())}
              size={24}
              color={getConfigEmpresa.coresPWA.corFontePrimaria}
              style={{ marginRight: 8 }}
            />{" "}
            {titulo_principal}
          </Text>
        </Flex>

        <Box style={styles.container}>
          {isValor ? null : (
            <Text style={styles.dateLabel} fontSize="md">
              {subtitulo}
            </Text>
          )}
          <Text style={styles.dateValue} fontSize="md">
            {valor}
          </Text>
        </Box>
      </Box>
    );
  }

  function finalizar() {
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: "TabNavigator", params: { screen: "Inicio" } }],
      }),
    );
  }

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o template antigo
  const utilizaLayoutLegado =
    getConfigEmpresa.utilizaPwaSimples ||
    getConfigEmpresa.versaoPWA == 2 ||
    getConfigEmpresa.utilizaTemaEscuro;

  const corPrincipal: string = primaryColor || "#006400";
  const corTextoPrincipal = corTextoSobre(corPrincipal);

  function formatarValor(valor: any) {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function renderLinhaTicket(rotulo: string, valor: string, destaque = false) {
    return (
      <View style={stylesNovo.linhaTicket}>
        <RNText style={stylesNovo.rotuloTicket}>{rotulo}</RNText>
        <RNText
          style={[
            stylesNovo.valorTicket,
            destaque && { color: corPrincipal, fontSize: 17, fontWeight: "800" },
          ]}
        >
          {valor}
        </RNText>
      </View>
    );
  }

  if (!utilizaLayoutLegado) {
    const data: Date | null = parametros?.data_selecionada
      ? new Date(parametros.data_selecionada)
      : null;
    const primeiroNome = String(parametros?.nome_cliente || "")
      .trim()
      .split(" ")[0];
    const servicos: string[] = parametros?.nomes_servicos || [];
    const endereco: string = getConfigEmpresa.endereco || "";
    const linkRota = endereco
      ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          endereco,
        )}`
      : "";

    let mensagemEspera = "Te esperamos";
    if (data) {
      mensagemEspera +=
        (data.getDay() === 0 || data.getDay() === 6 ? " no " : " na ") +
        DIAS_CURTOS[data.getDay()];
    }
    mensagemEspera += primeiroNome ? `, ${primeiroNome}.` : "!";

    return (
      <View style={stylesNovo.container}>
        <ScrollView
          style={{ flex: 1, width: "100%" }}
          contentContainerStyle={{ alignItems: "center", paddingBottom: 24 }}
        >
          {/* Topo de celebração */}
          <div
            style={{
              position: "relative",
              overflow: "hidden",
              width: "100%",
              boxSizing: "border-box",
              paddingTop: 44,
              paddingBottom: 90,
              paddingLeft: 20,
              paddingRight: 20,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: corPrincipal,
              backgroundImage: gradienteHero(corPrincipal),
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
            }}
          >
            <div style={circulo(220, -60, -70)} />
            <div style={circulo(140, -20, -30)} />

            <View style={stylesNovo.anelCheck}>
              <View style={stylesNovo.circuloCheck}>
                <Feather name="check" size={34} color={corPrincipal} />
              </View>
            </View>

            <RNText style={[stylesNovo.tituloSucesso, { color: corTextoPrincipal }]}>
              Agendamento{"\n"}confirmado!
            </RNText>
            <RNText
              style={[stylesNovo.subtituloSucesso, { color: corTextoPrincipal }]}
            >
              {mensagemEspera}
            </RNText>
          </div>

          <View style={stylesNovo.largura}>
            {/* Ticket */}
            <View style={[stylesNovo.ticket, sombraCard]}>
              {!!data && (
                <View style={stylesNovo.topoTicket}>
                  <View
                    style={[
                      stylesNovo.caixaData,
                      { backgroundColor: corComAlpha(corPrincipal, 0.1) },
                    ]}
                  >
                    <RNText style={[stylesNovo.mesCaixa, { color: corPrincipal }]}>
                      {MESES_CURTOS[data.getMonth()]}
                    </RNText>
                    <RNText style={stylesNovo.diaCaixa}>{data.getDate()}</RNText>
                  </View>
                  <View>
                    <RNText style={stylesNovo.semanaTicket}>
                      {DIAS_SEMANA[data.getDay()]}
                    </RNText>
                    <RNText style={stylesNovo.horaTicket}>
                      às {parametros?.horario}
                    </RNText>
                  </View>
                </View>
              )}

              {/* divisória pontilhada com recortes */}
              <View style={stylesNovo.divisoria}>
                <View style={[stylesNovo.recorte, { left: -9 }]} />
                <View style={stylesNovo.pontilhado} />
                <View style={[stylesNovo.recorte, { right: -9 }]} />
              </View>

              <View style={stylesNovo.corpoTicket}>
                {!!parametros?.nome_profissional &&
                  renderLinhaTicket("Profissional", parametros.nome_profissional)}
                {servicos.length > 0 &&
                  renderLinhaTicket("Serviços", servicos.join(" + "))}
                {renderLinhaTicket(
                  "Total",
                  parametros?.valor_total != null
                    ? formatarValor(parametros.valor_total)
                    : "R$ " + (parametros?.total ?? "0,00"),
                  true,
                )}
              </View>

              <View style={stylesNovo.rodapeTicket}>
                <RNText style={stylesNovo.rotuloCodigo}>CÓDIGO</RNText>
                <RNText style={stylesNovo.codigo}>
                  #{parametros?.id_agendamento}
                </RNText>
              </View>
            </View>

            {/* Endereço */}
            {!!endereco && (
              <View style={[stylesNovo.cardEndereco, sombraCard]}>
                <Feather name="map-pin" size={18} color={corPrincipal} />
                <View style={{ flex: 1 }}>
                  <RNText style={stylesNovo.nomeEmpresa}>
                    {getConfigEmpresa.nomeFantasia}
                  </RNText>
                  <RNText style={stylesNovo.endereco}>{endereco}</RNText>
                </View>
                <TouchableOpacity onPress={() => Linking.openURL(linkRota)}>
                  <RNText style={[stylesNovo.rota, { color: corPrincipal }]}>
                    Rota
                  </RNText>
                </TouchableOpacity>
              </View>
            )}
          </View>
        </ScrollView>

        <View style={stylesNovo.rodape}>
          <View style={stylesNovo.largura}>
            <TouchableOpacity
              activeOpacity={0.85}
              onPress={finalizar}
              style={[stylesNovo.botao, { backgroundColor: corPrincipal }]}
            >
              <Feather name="home" size={18} color={corTextoPrincipal} />
              <RNText style={[stylesNovo.textoBotao, { color: corTextoPrincipal }]}>
                Voltar ao início
              </RNText>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }

  // ---------------- Layout legado ----------------
  return (
    <Template
      titulo={"Comprovante"}
      ocultarBotaoCancelar
      escondeBotoesRodape={true}
      onBotaoProximoClick={() => {}}
    >
      <Card
        style={{
          margin: 2,
          width: "100%",
          backgroundColor: getConfigEmpresa.coresPWA.corFundo,
          borderColor:
            getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao || "#000",
          border: "solid",
        }}
      >
        <Flex
          direction={"row"}
          justifyContent={"center"}
          width={"100%"}
          alignItems={"center"}
        >
          {isMobile && (
            <AntDesign
              name="checkcircle"
              size={65}
              color={primaryColor ?? "defaultColor"}
              style={{ marginRight: 10 }}
            />
          )}
          {/* {isMobile && <Box style={styles.imageContainer}>
                    <Box style={[styles.innerBox, { backgroundColor: primaryColor ?? 'defaultColor' }]}>
                        <Text style={styles.checkmark} fontSize="6xl">✔</Text>
                    </Box>
                </Box>} */}

          <Box style={[styles.textContainer, !isMobile && { width: "100%" }]}>
            <Text style={styles.confirmedText} fontSize="md">
              AGENDAMENTO CONFIRMADO!
            </Text>
            <Text style={styles.codeText} fontSize="sm">
              COD DO SEU AGENDAMENTO #{parametros?.id_agendamento}
            </Text>
          </Box>
        </Flex>
      </Card>

      <Card
        style={{
          margin: 2,
          marginTop: 10,
          width: "100%",
          backgroundColor: getConfigEmpresa.coresPWA.corFundo,
          borderColor:
            getConfigEmpresa.coresPWA.corBordaLinhasConfirmacao || "#000",
          border: "solid",
        }}
      >
        {renderLinha(
          "Detalhes do Agendamento",
          "DATA E HORA",
          parametros?.data_hora_selecionada,
          false,
          true,
        )}
        {renderLinha(
          "Pagamento",
          "VALOR TOTAL",
          "R$ " + parametros?.total,
          false,
          true,
        )}
      </Card>
      {/* {renderLinhaFinal()} */}

      <Box style={styles.containerFinal}>
        <TouchableOpacity
          style={[
            styles.styleButtonFinal,
            { backgroundColor: primaryColor ?? "defaultColor" },
          ]}
          onPress={() => {
            finalizar();
          }}
        >
          <Text fontSize="lg" style={styles.buttonText} fontWeight="bold">
            <FontAwesome
              name="home"
              size={18}
              color="#fff"
              style={{ marginRight: 4 }}
            />
            INÍCIO
          </Text>
        </TouchableOpacity>
      </Box>
    </Template>
  );
}

const stylesNovo = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    alignItems: "center",
    backgroundColor: CORES.fundo,
  },
  largura: {
    width: "100%",
    maxWidth: 560,
    paddingHorizontal: 16,
  },
  anelCheck: {
    width: 96,
    height: 96,
    borderRadius: 48,
    padding: 10,
    backgroundColor: "rgba(255,255,255,0.12)",
    marginBottom: 18,
  },
  circuloCheck: {
    flex: 1,
    borderRadius: 40,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
  tituloSucesso: {
    fontSize: 28,
    lineHeight: 32,
    fontWeight: "800",
    textAlign: "center",
  },
  subtituloSucesso: {
    fontSize: 14,
    marginTop: 8,
    opacity: 0.85,
    textAlign: "center",
  },
  ticket: {
    marginTop: -60,
    backgroundColor: CORES.card,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: CORES.borda,
  },
  topoTicket: {
    flexDirection: "row",
    alignItems: "center",
    gap: 14,
    padding: 16,
  },
  caixaData: {
    width: 56,
    height: 60,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
  },
  mesCaixa: {
    fontSize: 11,
    fontWeight: "800",
    letterSpacing: 1,
  },
  diaCaixa: {
    fontSize: 22,
    lineHeight: 24,
    fontWeight: "800",
    color: CORES.titulo,
  },
  semanaTicket: {
    fontSize: 13,
    color: CORES.subtitulo,
  },
  horaTicket: {
    fontSize: 24,
    fontWeight: "800",
    color: CORES.titulo,
  },
  divisoria: {
    height: 18,
    justifyContent: "center",
  },
  pontilhado: {
    marginHorizontal: 16,
    borderTopWidth: 1.5,
    borderStyle: "dashed",
    borderColor: "rgba(0,0,0,0.12)",
  },
  recorte: {
    position: "absolute",
    top: 0,
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: CORES.fundo,
  },
  corpoTicket: {
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  linhaTicket: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 16,
    paddingVertical: 8,
  },
  rotuloTicket: {
    fontSize: 13,
    color: CORES.subtitulo,
  },
  valorTicket: {
    flex: 1,
    textAlign: "right",
    fontSize: 14,
    fontWeight: "700",
    color: CORES.titulo,
  },
  rodapeTicket: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 14,
    backgroundColor: "#F7F4EE",
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    borderTopWidth: 1,
    borderTopColor: CORES.borda,
  },
  rotuloCodigo: {
    fontSize: 11,
    fontWeight: "800",
    letterSpacing: 1.5,
    color: CORES.subtitulo,
  },
  codigo: {
    fontSize: 17,
    fontWeight: "800",
    color: CORES.titulo,
    letterSpacing: 1,
  },
  cardEndereco: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    marginTop: 14,
    padding: 16,
    borderRadius: 18,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
  },
  nomeEmpresa: {
    fontSize: 14,
    fontWeight: "700",
    color: CORES.titulo,
  },
  endereco: {
    fontSize: 12,
    color: CORES.subtitulo,
    marginTop: 2,
  },
  rota: {
    fontSize: 13,
    fontWeight: "800",
  },
  rodape: {
    width: "100%",
    alignItems: "center",
    backgroundColor: CORES.card,
    paddingTop: 14,
    paddingBottom: 18,
    borderTopLeftRadius: 22,
    borderTopRightRadius: 22,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -4 },
    shadowOpacity: 0.06,
    shadowRadius: 12,
    elevation: 8,
  },
  botao: {
    height: 52,
    borderRadius: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  textoBotao: {
    fontSize: 16,
    fontWeight: "700",
  },
});
